import { useContext, useEffect, useState } from "react"
import {
    SidePopupContainer, FlexColumn, Button,
    Form, FormGroup, FlexRow, AppSpan, Switch,
    ReactSelect,
    AppLabel,
    CustomContainer
} from "src/style"
import { RiCloseFill } from "react-icons/ri"
import ApiContext from "src/provider/API/call-service"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"
import { Roles, UserType, SSOUser } from "src/model"
import { ReactComponent as InstitutionFillIcon } from 'src/assets/img/institution-fill-icon.svg'
import { components } from "react-select"
import utility from "src/utils/utility"

export const Create_Edit_ClientUser: React.FC<any> = ({ getUsers, rowData, close }) => {
    const { API } = useContext(ApiContext)
    const {info: {userData}} = useContext(AppInfoContext)

    const institutionCode = userData?.institution?.code;
    
    const [input, setInput] = useState<any>({ type: UserType.CLIENT, id: '', firstName: '', lastName: '', email: '', roleId: null, isAdminRole: false })
    const [roles, setRoles] = useState<Array<Roles> | null>(null)
    const [users, setUsers] = useState<Array<SSOUser> | null>(null)
    const [selectedUser, setSelectedUser] = useState<any>(null)

    const { Option } = components;
    const IconOption = (props: any) => (
        <Option {...props}>
            <InstitutionFillIcon style={{ marginRight: '1.5rem' }} />
            {props.data.label}
        </Option>
    );

    useEffect(() => {
        if (rowData) {
            const { type, id, firstName, lastName, email, roleId, isAdminRole } = rowData
            setInput({ ...input, id, type, firstName, lastName, email, roleId, isAdminRole })
        }
    }, [rowData])

    useEffect(() => {
        handleFetchRoleByUserType()
        handleFetchSSOUsers(institutionCode)
    }, [])

    async function handleFetchRoleByUserType() {
        const response = await API.getRoleByUserType(UserType.CLIENT)
        if (response) setRoles(response)
    }

    async function handleFetchSSOUsers(userId: string) {
        const response = await API.getAllSSOUsers(userId)
        if (response) setUsers(response)
    }

    const handleInput = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => setInput({ ...input, [e.target.name]: e.target.value })

    async function handleSubmit(e: React.FormEvent<HTMLButtonElement | HTMLFormElement>) {
        e.preventDefault()

        const payload: any = {
            ...input,
            roleId: input.roleId.value,
            institutionCode: institutionCode
        }

        const response = await API.createUser(payload)
        if (response) {
            getUsers()
            close()
        }
    }

    async function handleSSOUser (val: any) {
        setSelectedUser(val)
        setInput({
            ...input, id: val.value.id, 
            firstName: val.value.firstName || '', lastName: val.value.lastName,
            email: val.value.email
        })

    }

    return (
        <>
            <SidePopupContainer zIndex="8" onClick={close} />
            <FlexColumn
                className="center-popup-container"
                justifyContent="flex-start"
                alignItems="flex-start"
            >
                <FlexRow justifyContent='space-between' gap='2'>
                    <AppSpan color='#101828' textSize='1.8' fontWeight="600">{rowData ? 'Edit User' : 'Create User'}</AppSpan>
                    <Button
                        titleSize="2" fontWeight="500"
                        width='3.4' shadow='none'
                        height='3.4'
                        radius='0.4'
                        bgColor='#ffffff'
                        hoverBgColor='#FEF3F2'
                        borderColor='none'
                        color='#000000'
                        hoverColor='#B42318'
                        onClick={close}
                    >
                        <RiCloseFill style={{ fontSize: '2.3rem' }} />
                    </Button>
                </FlexRow>
                <Form onSubmit={handleSubmit} topMargin='2'>
                    <CustomContainer>
                        <AppLabel 
                            bottomMargin="0.8" fontWeight="500" color="#344054"
                        >
                            User
                        </AppLabel>
                    <ReactSelect
                        bottomMargin="2"
                        styles={utility.reactSelectStyles()}
                        options={
                        users?.map((item: any, index: number) => ({
                            label: item.email,
                            value: item,
                            key: index
                        }))
                        }
                        isClearable={true}
                        isSearchable={true}
                        name='users'
                        placeholder="Select User"
                        menuPortalTarget={document.body}
                        value={selectedUser}
                        onChange={(val: any) => handleSSOUser(val)}
                        components={{ Option: IconOption }}
                    />
                    </CustomContainer>
                {selectedUser && (
                    <>
                        <FormGroup>
                            <label>First Name</label>
                            <input
                                placeholder="Enter first name"
                                name='firstName'
                                value={input.firstName}
                                onChange={handleInput}
                            />
                        </FormGroup>
                        <FormGroup>
                            <label>Last Name</label>
                            <input
                                placeholder="Enter last name"
                                name='lastName'
                                value={input.lastName}
                                onChange={handleInput}
                            />
                        </FormGroup>
                        <FormGroup>
                            <label>Email</label>
                            <input
                                placeholder="Enter email"
                                type='email'
                                name='email'
                                value={input.email}
                                onChange={handleInput}
                            />
                        </FormGroup>
                        </>
                    )}
                    <CustomContainer>
                        <AppLabel 
                            bottomMargin="0.8" fontWeight="500" color="#344054"
                        >
                            Role
                        </AppLabel>
                    <ReactSelect
                        bottomMargin="2"
                        styles={utility.reactSelectStyles()}
                        options={
                            roles?.map((item: any, index: number) => ({
                            label: item.name,
                            value: item.id,
                            key: index
                        }))
                        }
                        isClearable={true}
                        isSearchable={true}
                        name='role'
                        placeholder="Select Role"
                        menuPortalTarget={document.body}
                        value={input.roleId}
                        onChange={(val) => setInput({ ...input, roleId: val })}
                        components={{ Option: IconOption }}
                    />
                    </CustomContainer>
                    <FlexRow gap="1.5" alignItems="flex-start" justifyContent="flex-start" bottomMargin="2">
                        <AppSpan fontWeight="500" color="#344054">Admin Role</AppSpan>
                        <Switch
                            radius='1.17' bgColor='#E7E7E7'
                            checkedBgColor='#0D968F' checkedSliderBgColor="#ffffff"
                        >
                            <input
                                type="checkbox"
                                checked={input.isAdminRole}
                                onChange={(e) => setInput({ ...input, isAdminRole: e.target.checked })}
                            />
                            <div></div>
                            <span></span>
                        </Switch>
                    </FlexRow>

                    <FlexRow justifyContent='flex-end'>
                        <Button
                            width='12.9'
                            titleSize='1.4' fontWeight="500"
                            height='4' radius='0.8'
                            bottomMargin='1' hoverColor='#0D968F'
                            hoverBgColor='#fff' borderColor='#0D968F'
                        >
                            {rowData ? 'Save changes' : 'Submit'}
                        </Button>
                    </FlexRow>
                </Form>
            </FlexColumn>
        </>
    )
}